const parseOrigin = (value: string, fallbackOrigin: string): string | null => {
    try {
        return new URL(value).origin;
    } catch {
        try {
            return new URL(value, fallbackOrigin).origin;
        } catch {
            return null;
        }
    }
};

export const buildLogoutUrls = (apiHost: string, currentOrigin: string): string[] => {
    const apiOrigin = parseOrigin(apiHost, currentOrigin);
    const appOrigin = parseOrigin(currentOrigin, currentOrigin);
    const uniqueOrigins = [apiOrigin, appOrigin]
        .filter((value): value is string => Boolean(value))
        .filter((origin, index, allOrigins) => allOrigins.indexOf(origin) === index);

    return uniqueOrigins.map((origin) => `${origin}/api/auth/logout/`);
};
